import { outreach } from '@round/api';
import {
    AudioLookup,
    ConfigurationItem,
    getFilterItems,
    getOutputItems,
    getTargetItems,
    LocationLookup,
} from '../../../helpers';

export type ConfigurationGroup = {
    title: string;
    description: string;
    items: ConfigurationItem[];
};

type Lookups = AudioLookup & LocationLookup;

export function getConfigurationGroups(request: outreach.OutreachRequest, lookups: Lookups): ConfigurationGroup[] {
    return [
        {
            title: 'Targets',
            description: 'TikTok sounds and hashtags this request searches.',
            items: getTargetItems(request.targets, lookups),
        },
        {
            title: 'Filters',
            description: 'Narrows which creators count as a match.',
            items: getFilterItems(request.filters, lookups),
        },
        {
            title: 'Outputs',
            description: 'Columns returned alongside each creator.',
            items: getOutputItems(request.outputs),
        },
    ];
}
